<template>
  <div class="pages">
    <div class="pagesContent">
      <!-- <top-nav :leftData="leftData" :activeNav="$route.params.pathId"></top-nav> -->
      <div class="bottomeContent">
        <div class="title">
          <div class="name">{{ contentTitle }}</div>
          <div class="engName">{{englishName}}</div>
        </div>
        <div class="compContent">
          <insureOrderQuery v-if="$route.params.pathId === 'insureOrderQuery'"></insureOrderQuery>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import topNav from "@/components/topNav";
  import insureOrderQuery from "@/components/insureOrder/insureOrderQuery.vue";
  export default {
    name: "about",
    components: {
      // topNav,
      insureOrderQuery,
    },
    data() {
      return {
        leftData: {
          title: "客户服务",
          navs: [{
            name: "insureOrderQuery",
            text: "保单查询",
            title: '客户服务',
            fatherPath: "customer",
            english: "CUSTOMER SERVICE",
          }],
        },
      };
    },
    computed: {
      contentTitle() {
        return this.leftData.navs.find(
          (item) => item.name === this.$route.params.pathId
        ).title;
      },
      englishName() {
        return this.leftData.navs.find(
          (item) => item.name === this.$route.params.pathId
        ).english;
      },
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.title{
    margin-top: 56px;
  }
  .compContent {}
</style>